import { useSelector } from 'react-redux';
import { MemberCheck } from '@pass-frontend/data-access/common/edge';
import { EligibilityState } from '@pass-frontend/features/facility-checkin/data-access';

export function useCurrenEligibilityCheck() {
  const memberDetails: MemberCheck = useSelector(
    (state: EligibilityState) => state?.eligibility?.memberDetails,
  );

  const searchedLocationOption = useSelector(
    (state: EligibilityState) => state?.eligibility?.searchedLocationOption,
  );

  const searchedLocationList = useSelector(
    (state: EligibilityState) => state?.eligibility?.searchedLocationList,
  );

  const appliedGymsFilter = useSelector(
    (state: EligibilityState) => state?.eligibility?.appliedGymsFilter,
  );

  return {
    memberDetails,
    searchedLocationOption,
    searchedLocationList,
    appliedGymsFilter,
  };
}
